// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2-P6t","content":"LoadingAlert_content__LVJRl"};